<div>

    <form (formValid)="formValid.set($event)"
          (formDirty)="formDirty.set($event)"
          (formValueChange)="formValue.set($event)">

        <div class="mce-form-section">

            <div class="mce-form-section-title">Message of the Day</div>

            <div class="grid-cols-[2fr_1fr_auto] grid gap-4">

                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Message of the Day</mat-label>
                        <textarea matInput placeholder="enter message of the day"
                                  name="html"
                                  [ngModel]="vm.formValue.html"
                                  #html=ngModel
                                  test-id="html"></textarea>
                        <mat-hint>Can use HTML.</mat-hint>
                    </mat-form-field>
                </div>

                <div>
                    <mat-form-field>
                        <mat-label>choose a set end date</mat-label>
                        <input matInput
                               name="endDate"
                               [matDatepicker]="picker"
                               [ngModel]="vm.formValue.endDate"
                               #endDate="ngModel">
                        <mat-hint>DD/MM/YYYY</mat-hint>
                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <div>
                    <button mat-raised-button color="primary"
                            (click)="setMOTD()">
                        Set MOTD
                    </button>

                </div>

            </div>

        </div>

    </form>

    @if (vm.showSpinner) {
        <div class="spinner-center spinner-overlay">
            <mat-spinner test-id="spinner"></mat-spinner>
        </div>
    }

</div>

